import React, { useEffect, useState } from 'react';
import { JobRow } from './../JobRow/JobRow';
import { WPSearchResultItem } from './../../typings';
import * as styles from './JobList.module.scss';

interface JobListProps {
  jobs: WPSearchResultItem[];
}

export const JobList:React.FC<JobListProps> = (props) => {

  return (
    <ul className={styles['job-list']}>
      {props.jobs.map((job:WPSearchResultItem) => (
        <JobRow
          key={job.id}
          refId={job.ref ?? ""}
          source={job.source}
          id={job.id}
          title={job.title}
          location={job.location}
          sbu={job.sbu}
          contract_type={job.contract_type}
          department={job.department}
          experience_level={job.experience_level}
          professional_communities={job.professional_communities}
        />
      ))}
    </ul>
  );
}